var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.9 0 4 0.9 4 2V30C4 31.1 4.9 32 6 32H26C27.1 32 28 31.1 28 30V8L20 0H6Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H28L20 0V6C20 7.1 20.9 8 22 8Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L22 8H28V14Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26C24 26.55 23.55 27 23 27H1C0.45 27 0 26.55 0 26V16C0 15.45 0.45 15 1 15H23C23.55 15 24 15.45 24 16V26Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35901 18.947C4.35901 18.683 4.56701 18.395 4.90201 18.395H6.74901C7.78901 18.395 8.72501 19.091 8.72501 20.425C8.72501 21.689 7.78901 22.393 6.74901 22.393H5.41401V23.449C5.41401 23.801 5.19001 24 4.90201 24C4.63801 24 4.35901 23.801 4.35901 23.449V18.947ZM5.41401 19.402V21.394H6.74901C7.28501 21.394 7.70901 20.921 7.70901 20.425C7.70901 19.866 7.28501 19.402 6.74901 19.402H5.41401Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.291 23.9998C10.027 23.9998 9.73901 23.8558 9.73901 23.5048V18.9628C9.73901 18.6758 10.027 18.4668 10.291 18.4668H12.122C15.776 18.4668 15.696 23.9998 12.194 23.9998H10.291ZM10.795 19.4428V23.0248H12.122C14.281 23.0248 14.377 19.4428 12.122 19.4428H10.795Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9919 19.5068V20.7778H19.0309C19.3189 20.7778 19.6069 21.0658 19.6069 21.3448C19.6069 21.6088 19.3189 21.8248 19.0309 21.8248H16.9919V23.5038C16.9919 23.7838 16.7929 23.9988 16.5129 23.9988C16.1609 23.9988 15.9459 23.7838 15.9459 23.5038V18.9618C15.9459 18.6748 16.1619 18.4658 16.5129 18.4658H19.3199C19.6719 18.4658 19.8799 18.6748 19.8799 18.9618C19.8799 19.2178 19.6719 19.5058 19.3199 19.5058H16.9919V19.5068Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H4V28H23C23.55 28 24 27.55 24 27V26C24 26.55 23.55 27 23 27Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfLogo);
export default __webpack_public_path__ + "static/media/pdfLogo.9cdb5412e060cd4bd2a1eb36f421a8c3.svg";
export { ForwardRef as ReactComponent };